import { render } from "./HomeFourPage.vue?vue&type=template&id=e5b9ed40&ts=true"
import script from "./HomeFourPage.vue?vue&type=script&lang=ts"
export * from "./HomeFourPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__